__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/09-02-2026_Fossil_V5/";